import { INTERVIEW_SECTIONS } from "../types/interviewTypes"
import NavigationBarItem from "./NavigationBarItem"
import navigationLabels from "./navigationLabels"

export const navigationItems = [
  {
    label: navigationLabels.recordMgmt,
    section: "recordMgmt",
    intake: true,
    template: (item, options) => {
      return <NavigationBarItem item={item} options={options} />
    },
    command: () => {},
  },
  {
    label: navigationLabels.startInterview,
    section: "start",
    template: (item, options) => {
      return <NavigationBarItem item={item} options={options} />
    },
    command: () => {},
    start: true,
  },
  {
    label: navigationLabels.demographics,
    section: INTERVIEW_SECTIONS.DEMOGRAPHICS,
    intake: true,
    template: (item, options) => {
      return <NavigationBarItem item={item} options={options} />
    },
  },
  {
    label: navigationLabels.substanceUse1,
    section: INTERVIEW_SECTIONS.SUBSTANCE_USE_1,
    all: true,
    template: (item, options) => {
      return <NavigationBarItem item={item} options={options} />
    },
    command: () => {},
  },
  {
    label: navigationLabels.substanceUse2,
    section: INTERVIEW_SECTIONS.SUBSTANCE_USE_2,
    all: true,
    template: (item, options) => {
      return <NavigationBarItem item={item} options={options} />
    },
    command: () => {},
  },
  {
    label: navigationLabels.substanceUse3,
    section: INTERVIEW_SECTIONS.SUBSTANCE_USE_3,
    all: true,
    template: (item, options) => {
      return <NavigationBarItem item={item} options={options} />
    },
    command: () => {},
  },
  {
    label: navigationLabels.plannedServices1,
    section: INTERVIEW_SECTIONS.PLANNED_SERVICES_1,
    intake: true,
    template: (item, options) => {
      return <NavigationBarItem item={item} options={options} />
    },
    command: () => {},
  },
  {
    label: navigationLabels.plannedServices2,
    section: INTERVIEW_SECTIONS.PLANNED_SERVICES_2,
    intake: true,
    template: (item, options) => {
      return <NavigationBarItem item={item} options={options} />
    },
    command: () => {},
  },
  {
    label: navigationLabels.plannedServices3,
    section: INTERVIEW_SECTIONS.PLANNED_SERVICES_3,
    intake: true,
    template: (item, options) => {
      return <NavigationBarItem item={item} options={options} />
    },
    command: () => {},
  },
  {
    label: navigationLabels.plannedServices4,
    section: INTERVIEW_SECTIONS.PLANNED_SERVICES_4,
    intake: true,
    template: (item, options) => {
      return <NavigationBarItem item={item} options={options} />
    },
    command: () => {},
  },
  {
    label: navigationLabels.living,
    section: INTERVIEW_SECTIONS.FAMILY,
    all: true,
    template: (item, options) => {
      return <NavigationBarItem item={item} options={options} />
    },
    command: () => {},
  },
  {
    label: navigationLabels.education,
    section: INTERVIEW_SECTIONS.EDUCATION,
    all: true,
    template: (item, options) => {
      return <NavigationBarItem item={item} options={options} />
    },
    command: () => {},
  },
  {
    label: navigationLabels.legal,
    section: INTERVIEW_SECTIONS.LEGAL,
    all: true,
    template: (item, options) => {
      return <NavigationBarItem item={item} options={options} />
    },
    command: () => {},
  },
  {
    label: navigationLabels.mental,
    section: INTERVIEW_SECTIONS.MENTAL,
    all: true,
    template: (item, options) => {
      return <NavigationBarItem item={item} options={options} />
    },
    command: () => {},
  },
  {
    label: navigationLabels.social,
    section: INTERVIEW_SECTIONS.SOCIAL,
    all: true,
    template: (item, options) => {
      return <NavigationBarItem item={item} options={options} />
    },
    command: () => {},
  },
  {
    label: navigationLabels.program,
    section: INTERVIEW_SECTIONS.PROGRAM,
    followUp: true,
    discharge: true,
    template: (item, options) => {
      return <NavigationBarItem item={item} options={options} />
    },
    command: () => {},
  },
  {
    label: navigationLabels.followUp,
    section: INTERVIEW_SECTIONS.FOLLOW_UP,
    followUp: true,
    template: (item, options) => {
      return <NavigationBarItem item={item} options={options} />
    },
    command: () => {},
    administrative: true,
  },
  {
    label: navigationLabels.discharge,
    section: INTERVIEW_SECTIONS.DISCHARGE,
    discharge: true,
    template: (item, options) => {
      return <NavigationBarItem item={item} options={options} />
    },
    command: () => {},
    administrative: true,
  },
  {
    label: navigationLabels.servicesReceived1,
    section: INTERVIEW_SECTIONS.SERVICES_RECEIVED_1,
    discharge: true,
    template: (item, options) => {
      return <NavigationBarItem item={item} options={options} />
    },
    command: () => {},
  },
  {
    label: navigationLabels.servicesReceived2,
    section: INTERVIEW_SECTIONS.SERVICES_RECEIVED_2,
    discharge: true,
    template: (item, options) => {
      return <NavigationBarItem item={item} options={options} />
    },
    command: () => {},
  },
  {
    label: navigationLabels.servicesReceived3,
    section: INTERVIEW_SECTIONS.SERVICES_RECEIVED_3,
    discharge: true,
    template: (item, options) => {
      return <NavigationBarItem item={item} options={options} />
    },
    command: () => {},
  },
  {
    label: navigationLabels.servicesReceived4,
    section: INTERVIEW_SECTIONS.SERVICES_RECEIVED_4,
    discharge: true,
    template: (item, options) => {
      return <NavigationBarItem item={item} options={options} />
    },
    command: () => {},
  },
  {
    label: navigationLabels.servicesReceived5,
    section: INTERVIEW_SECTIONS.SERVICES_RECEIVED_5,
    discharge: true,
    template: (item, options) => {
      return <NavigationBarItem item={item} options={options} />
    },
    command: () => {},
  },
  {
    label: navigationLabels.summary,
    section: "summary",
    all: true,
    template: (item, options) => {
      return <NavigationBarItem item={item} options={options} />
    },
    command: () => {},
    summary: true,
    administrative: true,
  },
]
